// extracted by mini-css-extract-plugin
module.exports = {"home":"NorteHome_home__qDtgn"};